import DropdownsOnHoverInstance from './DropdownsOnHoverInstance.component';

export default DropdownsOnHoverInstance;
